/**
 * Класс, сожержит всякие улильные алгоритмы связанные с Keycloak.
 */
export class DxKeycloakUtils {
  /**
   * Собирает `URL` для `POST`-запроса аунтфикации пользователя в сервисе Keycloak.
   * @param {string} serverUrl - адрес сервера Keycloak.
   * @param {string} realm - идентификатор множества, содержащего: пользователей, учетные данные, группы и роли.
   * @return {string} - url для аунтификации пользователя.
   */
  public static buildAuthRequestUrl(serverUrl: string, realm: string): string {
    return serverUrl + '/auth/realms/' + realm + '/protocol/openid-connect/token';
  }


  /**
   * Подготоваливает тело для `POST`-запроса аунтфикации пользователя в сервисе Keycloak.
   * @param {string} clientId - идентификатор Keycloak-клиента (проксирующий сервис кейклоак
   *                            который уже обращается к остальным сервисам Keycloak).
   * @param {string} login - логин пользователя.
   * @param {string} password - пароль.
   * @return {any} - данные для анутификации пользователя в Keycloak.
   */
  public static prepareAuthRequestData(clientId: string, login: string, password: string): any {
    return 'client_id='
      + clientId
      + '&grant_type=password&username='
      + encodeURIComponent(login)
      + '&password='
      + encodeURIComponent(password);
  }

  /**
   * Подготоваливает тело для `POST`-запроса аунтфикации пользователя в сервисе Keycloak.
   * @param {string} clientId - идентификатор Keycloak-клиента (проксирующий сервис кейклоак
   *                            который уже обращается к остальным сервисам Keycloak).
   * @param {string} refreshToken - рефреш-токен для обновления токена.
   * @return {any} - данные для обновления токена в Keycloak.
   */
  public static prepareTokenRefreshRequestData(clientId: string, refreshToken: string): any {
    return 'client_id='
            + encodeURIComponent(clientId)
            + '&grant_type=refresh_token&refresh_token='
            + refreshToken;
  }
}
